import { isBefore, subHours } from 'date-fns';
import { changeLanguage } from 'i18next';

import { AuthenticatedUser } from './types';
import { authStorage } from './storage';

export function validateSession({ accessValidity }: AuthenticatedUser): boolean {
  try {
    if (!accessValidity) return false;

    const today = new Date();
    const accessLimit = subHours(new Date(accessValidity), 2);

    const accessLimitExpired = isBefore(accessLimit, today);

    return !accessLimitExpired;
  } catch (err) {
    return false;
  }
}

export function getSavedUserInfo(): AuthenticatedUser {
  const user = authStorage.user.get();

  if (!user) return { data: {} } as AuthenticatedUser;

  changeLanguage(user.data.language || 'en');

  const validSession = validateSession(user);

  if (validSession) return user;

  authStorage.user.delete();

  return { data: {} } as AuthenticatedUser;
}
